export enum RoomStatusKind {
    PENDING = 0,
    OPEN = 1,
    CLOSED = 2
}
